import React from 'react';
import PropTypes from 'prop-types';
import Form from '../../../components/user/variety/varietyForm';
import Layout from '../../../components/layouts/verticalLayout';
import { useParams } from 'react-router-dom';

const VarietyFormPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Form uuid={uuid} />} />;
};

VarietyFormPage.propTypes = {};

export default VarietyFormPage;
